import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import LazyLoad from 'react-lazyload';

import '@dom/style';

import { App } from '@dom/app';
import { Footer } from './components';
import { NavBar, ScrollToTopOnMount, LoginModal } from '@dom/components';

import { Home, Listings, Payment, Profile, EditProfile, PaymentSuccess, PaymentFailure } from './screens';

import {
  storeToken,
  initUserInfo,
} from '@dom/app/src/actions/auth';

import { isUserLoggedIn } from '@dom/utils';
import { useEffectOnFirstRender } from './hooks/useLifeCycles';

const GuideApp = () => {
  return (
    <BrowserRouter basename="/guides">
      <App modules={['user', 'auth', 'ratings', 'reviews']}>
        <ConnectedLoginUser />
        <NavBar />
        <LoginModal />
        <ScrollToTopOnMount />
        <Switch>
          <Route path="/:name.:id(a[a-z0-9A-Z]{11})/edit" render={props => <EditProfile {...props} />} />
          <Route path="/:name.:id(a[a-z0-9A-Z]{11})" component={Profile} />
          <Route exact path="/" component={Home} />
          <Route exact path="/list" component={Listings} />
          <Route exact path="/payment" component={Payment} />
          <Route exact path="/payment/success" component={PaymentSuccess} />
          <Route exact path="/payment/fail" component={PaymentFailure} />
          {/* <Route exact path="/services" component={AdditionalServices} /> */}
        </Switch>
        <LazyLoad offset={100}>
          <Footer />
        </LazyLoad>
      </App>
    </BrowserRouter>
  );
};

export default GuideApp;

const LoginUser = (props) => {
  useEffectOnFirstRender(() => {
    if (isUserLoggedIn()) {
      const { initUserInfo, storeToken } = props;
      const { token, roles, id } = localStorage;
      
      storeToken(token, roles, id);
      initUserInfo();
    }
  });
  return null;
};

const ConnectedLoginUser = connect(null, {
  storeToken,
  initUserInfo,
})(LoginUser);
